export function fetchBankAccountsRequest() {
  const fetchBankAccountsRequestOptions = {
    method: "GET",
  };

  const bankAccountsUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/loan/bank-accounts`;
  return fetch(bankAccountsUrl, fetchBankAccountsRequestOptions);
}

export function saveBankAccountsRequest(bankAccount) {
  const saveBankAccountsRequestOptions = {
    method: "POST",
    body: JSON.stringify(bankAccount),
  };

  const bankAccountsUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/loan/bank-accounts`;
  return fetch(bankAccountsUrl, saveBankAccountsRequestOptions);
}
